import React, { useState } from 'react';

export default function GalleryView({ images, title }) {
  const [activeIndex, setActiveIndex] = useState(null);

  if (!images || images.length === 0) return null;

  const handlePrev = (e) => {
    e.stopPropagation();
    setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleClose = () => {
    setActiveIndex(null);
  };

  return (
    <div className="w-full">
      {/* Grid of Images */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {images.map((imgUrl, idx) => {
          // Apply Cloudflare image resizing for performance
          const resizedUrl = imgUrl.startsWith('https://assets.auxodev.dk')
            ? imgUrl.replace('https://assets.auxodev.dk/assets/', 'https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/')
            : imgUrl;

          return (
            <div
              key={idx}
              onClick={() => setActiveIndex(idx)}
              className="relative aspect-4/3 rounded-3xl overflow-hidden bg-[--color-brand-sand] border border-[--color-brand-sand] cursor-pointer group shadow-sm hover:shadow-md transition-all duration-300"
            >
              <img
                src={resizedUrl}
                alt={`${title || 'Galleri'} - Billede ${idx + 1}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
                <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center text-[--color-brand-green-dark] shadow-md transform scale-90 group-hover:scale-100 transition-all duration-300">
                  <i className="fa-solid fa-expand text-lg"></i>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Lightbox Modal */}
      {activeIndex !== null && (
        <div
          onClick={handleClose}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4 md:p-8 animate-fade-in"
        >
          {/* Close Button */}
          <button
            onClick={handleClose}
            className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors cursor-pointer z-50"
            aria-label="Luk galleri"
          >
            <i className="fa-solid fa-xmark text-xl"></i>
          </button>

          {/* Previous Button */}
          {images.length > 1 && (
            <button
              onClick={handlePrev}
              className="absolute left-4 md:left-8 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors cursor-pointer z-50"
              aria-label="Forrige billede"
            >
              <i className="fa-solid fa-chevron-left text-lg"></i>
            </button>
          )}

          {/* Image Container */}
          <div className="relative max-w-5xl max-h-[85vh] flex flex-col items-center justify-center">
            <img
              src={images[activeIndex]}
              alt={`${title || 'Galleri'} - Billede ${activeIndex + 1}`}
              className="max-w-full max-h-[80vh] object-contain rounded-xl select-none"
              onClick={(e) => e.stopPropagation()}
            />
            <p className="text-white/70 text-sm mt-4 font-sans tracking-wide">
              Billede {activeIndex + 1} af {images.length}
            </p>
          </div>

          {/* Next Button */}
          {images.length > 1 && (
            <button
              onClick={handleNext}
              className="absolute right-4 md:right-8 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors cursor-pointer z-50"
              aria-label="Næste billede"
            >
              <i className="fa-solid fa-chevron-right text-lg"></i>
            </button>
          )}
        </div>
      )}
    </div>
  );
}
